<template>
    <div class="date-time-picker">
        <date-picker :value="date"
                     @input="date = $event"
                     :id="id"
                     :default="defaultDate"
                     :input-format="formatDate"
                     :display-format="displayFormatDate"
                     :allow-empty="allowEmpty"
                     :min="minDate"
                     :max="maxDate"
                     :small="small"
                     :disabled="disabled"
        />
        <time-picker :value="time"
                     @input="time = $event"
                     :default="defaultTime"
                     :input-format="formatTime"
                     :display-format="displayFormatTime"
                     :allow-empty="allowEmpty"
                     :small="small"
                     :disabled="disabled"
        />
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        props: {
            value: String,
            id: {required: false, type: String},
            defaultDate: {type: String, default: 'now'},
            defaultTime: {type: String, default: '00:00'},
            inputFormat: {type: String, default: 'YYYY-MM-DD HH:mm:ss'},
            displayFormatDate: {type: String, default: 'DD.MM.YYYY'},
            displayFormatTime: {type: String, default: 'HH:mm'},
            small: {type: Boolean, default: false},
            disabled: {type: Boolean, default: false},
            allowEmpty: {type: Boolean, default: true},
            min: {type: String, default: null},
            max: {type: String, default: null},
        },

        data() {
            return {
                formatDate: 'YYYY-MM-DD',
                formatTime: 'HH:mm',
            };
        },

        computed: {
            dateObject() {
                return moment(this.value, this.inputFormat);
            },

            date: {
                get() {
                    if (this.value === '' || this.value === null) {
                        return null;
                    }
                    return this.dateObject.format(this.formatDate);
                },
                set(value) {
                    if (value === null) {
                        this.$emit('input', null);
                    } else {
                        this.$emit('input', this.union(value, this.time).format(this.inputFormat));
                    }
                },
            },

            time: {
                get() {
                    if (this.value === '' || this.value === null) {
                        return null;
                    }
                    return this.dateObject.format(this.formatTime);
                },
                set(value) {
                    if (value === null) {
                        this.$emit('input', null);
                    } else {
                        this.$emit('input', this.union(this.date, value).format(this.inputFormat));
                    }
                },
            },

            minDate() {
                if (!this.min) {
                    return null;
                }
                if (this.min === 'now') {
                    return 'now';
                }
                return moment(this.min, this.inputFormat).format(this.dateFormat);
            },

            maxDate() {
                if (!this.max) {
                    return null;
                }
                if (this.max === 'now') {
                    return 'now';
                }
                return moment(this.max, this.inputFormat).format(this.dateFormat);
            },
        },

        methods: {
            union(date, time) {
                date = moment(date || (this.defaultDate === 'now' ? new Date : this.defaultDate), this.formatDate);
                time = moment(time || (this.defaultTime === 'now' ? new Date : this.defaultTime), this.formatTime);
                date.hour(time.hour());
                date.minute(time.minute());
                date.second(time.second());
                return date;
            },
        },
    };
</script>